import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

// API
// Wishlist Ids

export const STROLLERS_WISHLIST_IDS_FETCH_REQUEST = 'STROLLERS_WISHLIST_IDS_FETCH_REQUEST';

export interface StrollersWishlistIdsFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLERS_WISHLIST_IDS_FETCH_REQUEST;
}

export interface StrollersWishlistIdsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { wishlistIds: string[]; };
}

export const STROLLERS_WISHLIST_IDS_FETCH_SUCCESS = 'STROLLERS_WISHLIST_IDS_FETCH_SUCCESS';
export interface StrollersWishlistIdsFetchSuccessAction extends APISuccessAction<StrollersWishlistIdsFetchNormalizedResponse> {
    readonly type: typeof STROLLERS_WISHLIST_IDS_FETCH_SUCCESS;
}

export const STROLLERS_WISHLIST_IDS_FETCH_FAILURE = 'STROLLERS_WISHLIST_IDS_FETCH_FAILURE';

export interface StrollersWishlistIdsFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLERS_WISHLIST_IDS_FETCH_FAILURE;
}

export const strollersWishlistIdsFetch = {
    request: (): StrollersWishlistIdsFetchRequestAction => ({
        type: STROLLERS_WISHLIST_IDS_FETCH_REQUEST,
    }),
    success: (response: StrollersWishlistIdsFetchNormalizedResponse): StrollersWishlistIdsFetchSuccessAction => ({
        type: STROLLERS_WISHLIST_IDS_FETCH_SUCCESS, response,
    }),
    failure: (error: any): StrollersWishlistIdsFetchFailureAction => ({
        type: STROLLERS_WISHLIST_IDS_FETCH_FAILURE, error,
    }),
};

// Wishlist items
export const STROLLERS_WISHLIST_ITEMS_FETCH_TRIGGER = 'STROLLERS_WISHLIST_ITEMS_FETCH_TRIGGER';
export interface StrollersWishlistItemsFetchTriggerAction {
    readonly type: typeof STROLLERS_WISHLIST_ITEMS_FETCH_TRIGGER;
    readonly after: string;
}
export const STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST = 'STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST';
export interface StrollersWishlistItemsFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST;
    readonly after: string;
}
export interface StrollersWishlistItemsFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { strollers: number[]; };
}
export const STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS = 'STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS';
export interface StrollersWishlistItemsFetchSuccessAction extends APISuccessAction<StrollersWishlistItemsFetchNormalizedResponse> {
    readonly type: typeof STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS;
    readonly after: string;
    readonly hasMore: boolean;
}
export const STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE = 'STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE';
export interface StrollersWishlistItemsFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE;
    readonly after: string;
}

export const strollersWishlistItemsFetchTrigger = (after?: string): StrollersWishlistItemsFetchTriggerAction => ({
    type: STROLLERS_WISHLIST_ITEMS_FETCH_TRIGGER, after,
});
export const strollersWishlistItemsFetchApi = {
    request: (after: string): StrollersWishlistItemsFetchRequestAction => ({
        type: STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST, after,
    }),
    success: (after: string, hasMore: boolean, response: StrollersWishlistItemsFetchNormalizedResponse): StrollersWishlistItemsFetchSuccessAction => ({
        type: STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS, after, hasMore, response,
    }),
    failure: (after: string, error: any): StrollersWishlistItemsFetchFailureAction => ({
        type: STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE, after, error,
    }),
};

// Wishlist toggle
export const STROLLERS_WISHLIST_TOGGLE_TRIGGER = 'STROLLERS_WISHLIST_TOGGLE_TRIGGER';
export interface StrollersWishlistToggleAction extends Action {
    readonly type: typeof STROLLERS_WISHLIST_TOGGLE_TRIGGER;
    readonly id: number;
}
export const STROLLERS_WISHLIST_TOGGLE_REQUEST = 'STROLLERS_WISHLIST_TOGGLE_REQUEST';
export interface StrollersWishlistToggleRequestAction extends APIRequestAction {
    readonly type: typeof STROLLERS_WISHLIST_TOGGLE_REQUEST;
}
export const STROLLERS_WISHLIST_TOGGLE_SUCCESS = 'STROLLERS_WISHLIST_TOGGLE_SUCCESS';
export interface StrollersWishlistToggleSuccessAction extends APISuccessAction {
    readonly type: typeof STROLLERS_WISHLIST_TOGGLE_SUCCESS;
    readonly id: number;
}
export const STROLLERS_WISHLIST_TOGGLE_FAILURE = 'STROLLERS_WISHLIST_TOGGLE_FAILURE';
export interface StrollersWishlistToggleFailureAction extends APIFailureAction {
    readonly type: typeof STROLLERS_WISHLIST_TOGGLE_FAILURE;
}

export const strollersWishlistToggle = (id: number): StrollersWishlistToggleAction => ({
    type: STROLLERS_WISHLIST_TOGGLE_TRIGGER,
    id,
});
export const strollersWishlistToggleApi = {
    request: (): StrollersWishlistToggleRequestAction => ({
        type: STROLLERS_WISHLIST_TOGGLE_REQUEST,
    }),
    success: (id: number, response: any): StrollersWishlistToggleSuccessAction => ({
        type: STROLLERS_WISHLIST_TOGGLE_SUCCESS, id, response,
    }),
    failure: (error: any): StrollersWishlistToggleFailureAction => ({
        type: STROLLERS_WISHLIST_TOGGLE_FAILURE, error,
    }),
};

// Triggers
export const STROLLERS_WISHLIST_IDS_LOAD = 'STROLLERS_WISHLIST_IDS_LOAD';
export interface StrollersWishlistIdsLoadAction extends Action {
    readonly type: typeof STROLLERS_WISHLIST_IDS_LOAD;
}
export const strollersWishlistIdsLoad = (): StrollersWishlistIdsLoadAction => ({
    type: STROLLERS_WISHLIST_IDS_LOAD,
});
